import { convertAPIDateResponse } from "../utils/convertAPIDate";
import mapKnownValues from "../utils/mapKnownValues";
import Address from "./address";

export type UserDetailsResponse = {
  userDetailsId: number;
  firstName: string;
  middleName: string;
  lastName: string;
  suffix: string;
  citizenship: string;
  dateOfBirth: string;
  ssnOrTin: string;
  maritalStatus: string;
  spouseEmail: string;
  spouseName: string;
  spousePhoneNumber: string;
  signatureFileName: string;
  userOnboarded: boolean;
  userIdentityId: number;
  address: { addressLine1: string; addressLine2: string; city: string; state: string; zipCode: string } | null;
  employer: any | undefined;
};

export default class UserDetails {
  userDetailsId = NaN;
  firstName = "";
  middleName = "";
  lastName = "";
  suffix = "";
  citizenship = "";
  dateOfBirth: undefined | Date = undefined;
  ssnOrTin = "";
  maritalStatus = "";
  spouseName = "";
  spouseEmail = "";
  spousePhoneNumber = "";
  signatureFileName = "";
  userOnboarded = false;
  userIdentityId = NaN;
  address = new Address();

  constructor(params: Partial<UserDetails> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: UserDetailsResponse) {
    return new UserDetails({
      ...response,
      address: response.address ? new Address(response.address) : undefined,
      dateOfBirth: convertAPIDateResponse(response.dateOfBirth),
    });
  }
}
